
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';


function postFormDataSpecialOrderQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function postFormDataSpecialOrderInput(
    specialOrderSubmission:
        DataServiceEntities.IWldSpecialOrderDetailsSubmission
): IDataServiceRequest {
    const query = postFormDataSpecialOrderQuery();
    return query.createDataServiceRequestForOperation(
        'PostFormDataSpecialOrder',
        true,
        ''
        ,
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            specialOrderSubmission: specialOrderSubmission
        }
    );
}

export function postFormDataSpecialOrderAsync(
    context: IContext, specialOrderSubmission:
        DataServiceEntities.IWldSpecialOrderDetailsSubmission
): AsyncResult<boolean> {
    const request = postFormDataSpecialOrderInput(specialOrderSubmission);
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function getZonePricesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function getZonePricesInput(
    queryResultSettings: IQueryResultSettings
): IDataServiceRequest {
    const query = getZonePricesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetZonePrices',
        false,
        DataServiceEntities.ZonePricingEntityExtensionClass
        ,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IZonePricingEntity' },
        {

        }
    );
}

export function getZonePricesAsync(
    context: IContext
): AsyncResult<DataServiceEntities.IZonePricingEntity[]> {
    const request = getZonePricesInput(
        context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IZonePricingEntity[]>(request, context.callerContext);
}

function postEveUomRequestQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function postEveUomRequestInput(
    queryResultSettings: IQueryResultSettings, productRequests:
        DataServiceEntities.IEveEachPriceRequestMap[],
    catalogId:
        number
): IDataServiceRequest {
    const query = postEveUomRequestQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'PostEveUomRequest',
        true,
        DataServiceEntities.EveEachPriceExtensionClass
        ,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IEveEachPrice' },
        {
            productRequests: productRequests,
            catalogId: catalogId
        }
    );
}

export function postEveUomRequestAsync(
    context: IContext, productRequests:
        DataServiceEntities.IEveEachPriceRequestMap[],
    catalogId:
        number
): AsyncResult<DataServiceEntities.IEveEachPrice[]> {
    const request = postEveUomRequestInput(
        context.queryResultSettings || {}, productRequests, catalogId);
    return callActionOrExecute<DataServiceEntities.IEveEachPrice[]>(request, context.callerContext);
}

function pastDueNoticeEntityQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function pastDueNoticeEntityInput(

): IDataServiceRequest {
    const query = pastDueNoticeEntityQuery();
    return query.createDataServiceRequestForOperation(
        'PastDueNoticeEntity',
        false,
        DataServiceEntities.HasAccountInCreditWrapperExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IHasAccountInCreditWrapper' },
        {

        }
    );
}

export function pastDueNoticeEntityAsync(
    context: IContext
): AsyncResult<DataServiceEntities.IHasAccountInCreditWrapper> {
    const request = pastDueNoticeEntityInput();
    return callActionOrExecute<DataServiceEntities.IHasAccountInCreditWrapper>(request, context.callerContext);
}

function addLicenseAndTaxPaymentToCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}


export function addLicenseAndTaxPaymentToCartInput(
    cartId:
        string,
    itemId:
        string,
    price:
        number,
    catalogId:
        number,
    cartVersion:
        number,
    productId:
        number
): IDataServiceRequest {
    const query = addLicenseAndTaxPaymentToCartQuery();
    return query.createDataServiceRequestForOperation(
        'AddLicenseAndTaxPaymentToCart',
        false,
        DataServiceEntities.AddLicenseAndTaxPaymentToCartResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAddLicenseAndTaxPaymentToCartResponse' },
        {
            cartId: cartId,
            itemId: itemId,
            price: price,
            catalogId: catalogId,
            cartVersion: cartVersion,
            productId: productId
        }
    );
}

export function addLicenseAndTaxPaymentToCartAsync(
    context: IContext, cartId:
        string,
    itemId:
        string,
    price:
        number,
    catalogId:
        number,
    cartVersion:
        number,
    productId:
        number
): AsyncResult<DataServiceEntities.IAddLicenseAndTaxPaymentToCartResponse> {
    const request = addLicenseAndTaxPaymentToCartInput(cartId, itemId, price, catalogId, cartVersion, productId);
    return callActionOrExecute<DataServiceEntities.IAddLicenseAndTaxPaymentToCartResponse>(request, context.callerContext);
}


// @ts-ignore
function eveFormQuery(formSubmissionId?: string): DataServiceQuery {
    const key = (formSubmissionId) ? { FormSubmissionId: formSubmissionId } : null;
    return new DataServiceQuery("EveForm", "FormSubmissionEntity", DataServiceEntities.FormSubmissionEntityExtensionClass, key);
}


export function createPostFormDataInput(templateId: string, formValues: DataServiceEntities.IFormSubmissionValue[], formTitle: string, emailTo: string): IDataServiceRequest {
    const query = eveFormQuery();
    return query.createDataServiceRequestForOperation('PostFormData', true, DataServiceEntities.PostFormSubmissionResponseExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPostFormSubmissionResponse' }, { TemplateId: templateId, FormValues: formValues, FormTitle: formTitle, EmailTo: emailTo });
}


export function postFormDataAsync(context: IContext, templateId: string, formValues: DataServiceEntities.IFormSubmissionValue[], formTitle: string, emailTo: string): AsyncResult<DataServiceEntities.IPostFormSubmissionResponse> {
    const request = createPostFormDataInput(templateId, formValues, formTitle, emailTo);
    return callActionOrExecute<DataServiceEntities.IPostFormSubmissionResponse>(request, context.callerContext);
}


// @ts-ignore
function wLDInventoryAlertControllerQuery(customerAccount?: string): DataServiceQuery {
    const key = (customerAccount) ? { CustomerAccount: customerAccount } : null;
    return new DataServiceQuery("WLDInventoryAlertController", "WLDInventoryAlertDataEntity", DataServiceEntities.WLDInventoryAlertDataEntityExtensionClass, key);
}


export function createGetCommunicationPreferencesStatusInput(): IDataServiceRequest {
    const query = wLDInventoryAlertControllerQuery();
    return query.createDataServiceRequestForOperation('GetCommunicationPreferencesStatus', true, DataServiceEntities.WLDCommunicationPreferencesExtensionClass, 'false', { bypassCache: 'none', returnEntity: 'DataServiceEntities.IWLDCommunicationPreferences' }, {});
}


export function getCommunicationPreferencesStatusAsync(context: IContext): AsyncResult<DataServiceEntities.IWLDCommunicationPreferences> {
    const request = createGetCommunicationPreferencesStatusInput();
    return callActionOrExecute<DataServiceEntities.IWLDCommunicationPreferences>(request, context.callerContext);
}

export function createSetCommunicationPreferencesStatusInput(emailName: string, isSubscribing: boolean): IDataServiceRequest {
    const query = wLDInventoryAlertControllerQuery();
    return query.createDataServiceRequestForOperation('SetCommunicationPreferencesStatus', true, DataServiceEntities.WLDCommunicationPreferencesExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IWLDCommunicationPreferences' }, { emailName: emailName, isSubscribing: isSubscribing });
}


export function setCommunicationPreferencesStatusAsync(context: IContext, emailName: string, isSubscribing: boolean): AsyncResult<DataServiceEntities.IWLDCommunicationPreferences> {
    const request = createSetCommunicationPreferencesStatusInput(emailName, isSubscribing);
    return callActionOrExecute<DataServiceEntities.IWLDCommunicationPreferences>(request, context.callerContext);
}

export function createSetCommunicationReportTypeInput(method: string): IDataServiceRequest {
    const query = wLDInventoryAlertControllerQuery();
    return query.createDataServiceRequestForOperation('SetCommunicationReportType', true, DataServiceEntities.WLDCommunicationPreferencesExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IWLDCommunicationPreferences' }, { method: method });
}


export function setCommunicationReportTypeAsync(context: IContext, method: string): AsyncResult<DataServiceEntities.IWLDCommunicationPreferences> {
    const request = createSetCommunicationReportTypeInput(method);
    return callActionOrExecute<DataServiceEntities.IWLDCommunicationPreferences>(request, context.callerContext);
}

export function createupdateEmailSubscriptionStatusInput(entityData: DataServiceEntities.IWLDInventoryAlertDataEntity): IDataServiceRequest {
    const query = wLDInventoryAlertControllerQuery();
    return query.createDataServiceRequestForOperation('updateEmailSubscriptionStatus', true, DataServiceEntities.WLDInventoryAlertEmailSubscriptionResponseEntityExtensionClass, 'false', { bypassCache: 'get', returnEntity: 'DataServiceEntities.IWLDInventoryAlertEmailSubscriptionResponseEntity' }, { entityData: entityData });
}


export function updateEmailSubscriptionStatusAsync(context: IContext, entityData: DataServiceEntities.IWLDInventoryAlertDataEntity): AsyncResult<DataServiceEntities.IWLDInventoryAlertEmailSubscriptionResponseEntity> {
    const request = createupdateEmailSubscriptionStatusInput(entityData);
    return callActionOrExecute<DataServiceEntities.IWLDInventoryAlertEmailSubscriptionResponseEntity>(request, context.callerContext);
}

function calculateSurchargeQuery(): DataServiceQuery {
    return new DataServiceQuery();
    }


export function calculateSurchargeInput (
  cartId:
      string,
      tenderTypeId:
      string
): IDataServiceRequest {
const query = calculateSurchargeQuery();
return query.createDataServiceRequestForOperation(
    'CalculateSurcharge',
    true, 
      DataServiceEntities.CalculateSurchargeResponseExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICalculateSurchargeResponse' },
    {
    cartId: cartId,
      tenderTypeId: tenderTypeId
    }
);
}

export function calculateSurchargeAsync (
  context: IContext, cartId:
      string,
      tenderTypeId:
      string
  ): AsyncResult<DataServiceEntities.ICalculateSurchargeResponse> {
  const request = calculateSurchargeInput(cartId, tenderTypeId);
  return callActionOrExecute<DataServiceEntities.ICalculateSurchargeResponse>(request, context.callerContext);
  }
